export const ALERT_HISTORY = 'alert/history';
export const LIST = 'list';
export const IS_LOADING = 'isLoading';
export const SELECTED_CATEGORY_ID = 'selectedCategoryId';
export const SELECTED_DATE_TIMESTAMP_IN_MS = 'selectedDateTimestampInMs';
export const SEARCH_VALUE = 'searchValue';
export const CURRENT_PAGE = 'currentPage';
export const IS_EMPTY_ALERT_HISTORY_LIST = 'isEmptyAlertHistoryList';
export const FIRST_PAGE_NUMBER = 0;
